<template>
  <div class="whole-page" style="overflow: visible">
    <section
      class="modal-upload-expo"
      :style="{
        backgroundImage:
          'url(' + require('@/assets/images/PTTSymmetryOscura02.jpg') + ')'
      }"
    >
      <div class="box terms inside-modal">
        <h1>
          <img
            :src="logo"
            @mouseover="logo = logo_blue"
            @mouseout="logo = logo_white"
            height="50"
            alt=""
            style="padding: 0; display: inline-block"
          />
          <span id="title">{{ this.title }}</span>
        </h1>
        <div class="terms-info text-center">
          <strong style="color: var(--white); font-size: 1.2rem"
            >Habeas Data</strong
          >
          <br /><br />
          <div class="col col-12 text-center progress-div" v-if="showLoading">
            <v-progress-circular
              indeterminate
              :width="3"
              color="primary"
            ></v-progress-circular>
          </div>
          <div v-for="(item, index) in termsBroken" :key="index">
            <p id="terms">{{ item }}</p>
          </div>
          <strong
            >No content on this website may be redistributed without prior
            written consent of
            <span class="qs-font">QUANSPIRE S.A.S.</span></strong
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { apiService } from "@/_services";
export default {
  data() {
    return {
      title: "",
      terms: "",
      breakingTag: "*@@*",
      termsBroken: [],
      logo_white: require("@/assets/images/symbol_white.png"),
      logo_blue: require("@/assets/images/symbol_blue.png"),
      logo: require("@/assets/images/symbol_white.png"),
      showLoading: true
    };
  },
  created() {
    this.getTerms();
    document.title = "Habeas Data | Quanspire";
  },
  methods: {
    getTerms() {
      //Getting terms and conditions
      let params = {
        method: "GET",
        endpoint: "catalogs",
        query_params: {
          format: "json",
          description: "HabeasData"
        }
      };
      apiService.getAll(params).then(data => {
        if (data != null) {
          data.forEach(element => {
            if (element["description"] === "HabeasData") {
              var jsonResponse = element["json"];
              this.title = jsonResponse.HabeasData[0].title;
              this.terms = jsonResponse.HabeasData[0].content;
              this.termsBroken = this.terms.split(this.breakingTag);
              console.log(this.termsBroken);
            }
          });
        } else {
          this.title = "Error: 204 No Content";
          this.termsBroken =
            ["Could not fetch data, please refresh or contact support."];
        }
        this.showLoading = false;
      });
    }
  }
};
</script>

<style scoped>
h1 {
  font-family: "Roboto", serif !important;
  height: auto !important;
}

.box {
  background: var(--darkbackground);
  color: var(--white);
  border: 1px solid var(--white);
  text-align: center;
  padding: 50px;
}

.box .terms {
  overflow-y: scroll !important;
  color: var(--white-gray);
}

.box.terms img {
  width: 50px;
  border: 1px solid white;
  border-radius: 50%;
  padding: 5px;
  margin-right: 20px;
}

.box .terms-info {
  padding: 0 50px;
}

.box img {
  width: 350px;
}

.box h1 {
  letter-spacing: 1px;
  color: white;
  text-transform: uppercase;
  font-weight: 300;
  font-size: 30px;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
